import { Priority, PriorityPppRef } from "@/types";

export interface PppGroup {
    key: string;
    /** null = deliverable has no PPP link (only reachable when candidates are in the list). */
    ppp: PriorityPppRef | null;
    items: Priority[];
}

export const sortedPpps = (ppps: PriorityPppRef[]) => [...ppps].sort((a, b) => a.orderIndex - b.orderIndex);

/** The PPP that decides where a deliverable ranks — its highest-ranked link. */
export const bestPpp = (priority: Priority): PriorityPppRef | null => sortedPpps(priority.ppps ?? [])[0] ?? null;

/**
 * Groups a server-ordered list under each item's best PPP. The list already arrives in derived
 * order (`MIN(ppp.order_index), created_at`), so first-seen insertion order *is* the PPP ranking —
 * nothing is re-sorted here.
 */
export function groupByPpp(list: Priority[]): PppGroup[] {
    const groups = new Map<string, PppGroup>();
    for (const priority of list) {
        const ppp = bestPpp(priority);
        const key = ppp?.pid ?? "none";
        if (!groups.has(key)) groups.set(key, { key, ppp, items: [] });
        groups.get(key)!.items.push(priority);
    }
    return [...groups.values()];
}
